import $ from 'jquery';
const SIZE_GUIDE = '#js-cartupsell-popup';
const SIZE_GUIDE_CLOSE = '.js-size-guide-close';
export const init = async function() {
    $(document).on('click', SIZE_GUIDE, ()=>{
        $('#js-cartupsell-overflow').fadeIn();
        $('#js-cartupsell-modal').fadeIn();
    });
    $(document).on('click', SIZE_GUIDE_CLOSE, ()=>{
        $('#js-cartupsell-overflow').fadeOut();
        $('#js-cartupsell-modal').fadeOut();
    });
    $(document).on('keyup', SIZE_GUIDE, (e)=>{
        if (e.keyCode === 13) {
            $('#js-cartupsell-overflow').fadeIn();
            $('#js-cartupsell-modal').fadeIn();
            $('.js-size-guide-close').focus();
        }
    });
    $(document).on('keyup', SIZE_GUIDE_CLOSE, (e)=>{
        if (e.keyCode === 13) {
            $('#js-cartupsell-overflow').fadeOut();
            $('#js-cartupsell-modal').fadeOut();
        }
    });
};
